import { render, staticRenderFns } from "./SourcesOverview.vue?vue&type=template&id=39706d5f&"
import script from "./SourcesOverview.vue?vue&type=script&lang=js&"
export * from "./SourcesOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports